<!-- add category modal -->
<div
  class="modal fade"
  id="add"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ expenseI18n?.addButtonI18n }}
        </h5>
        <button
          type="button"
          id="close"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-expense
          [expenseI18n]="expenseI18n"
          (closeModalEvent)="closeModalAdd()"
        ></app-add-expense>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ expenseI18n?.closeButtonI18n }}
        </button>
      </div>
    </div>
  </div>
</div>
